import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "なし", enum: "NONE" },
  { value: 2, text: "ホワイトリスト", enum: "WHITE" },
  { value: 3, text: "ブラックリスト", enum: "BLACK" },
]);
